module.exports = __webpack_public_path__ + "static/img/rule_bg.ccb7c37a.png";